import * as React from 'react';
import styled from 'styled-components';
import { ButtonLink } from 'components/Button';
import { mobile } from 'styles/breakpoints';
import colors from 'styles/colors.json';

const NewsLetterSubscriptionForm = () => {
  return (
    <div className="relative z-30 bg-color-bg-darkmode-primary px-gutter-base py-14 sm:py-20 lg:py-32">
      <Content className="mx-auto flex max-w-[1200px] flex-row items-center">
        <div>
          <h4 className="leading text-[2rem] font-bold italic text-white">Stay connected</h4>
          <p className="color-text-darkmode-tertiary mt-3	text-center text-base font-normal text-brand-gray-50 xs:mt-2 sm:text-left md:mt-6 md:text-xl">
            We'll keep you in the loop with our monthly newsletter.
          </p>
        </div>
        <div className="justify-end">
          <InputWithBtn className="relative flex w-full max-w-[384px] flex-col xs:mt-10 sm:flex-row ">
            <input
              className="input-form color-text-lightmode-inactive h-[48px] rounded-3xl"
              placeholder="Your email"
            />
            <button className="button-rounded-inline-background-bold right-0 mx-auto flex h-[3rem] items-center justify-center rounded-[28px] py-4 pb-2 pl-3 pr-3 pt-2 xs:w-full sm:absolute sm:mt-0 md:w-[7.8rem]">
              Get Started
            </button>
          </InputWithBtn>
        </div>
      </Content>
    </div>
  );
};

const InputWithBtn = styled.div`
  input {
    background: rgba(243, 242, 241, 0.15);
    color: ${colors.paletteBrandGray.colors[200]};

    :focus {
      outline: none;
      box-shadow: none;
    }
  }
`;

const Content = styled.div`
  ${mobile()} {
    flex-direction: column;
    justify-content: center;
  }

  > div {
    width: 50%;

    :last-child {
      margin-left: auto;
    }

    ${mobile()} {
      width: 100%;

      :first-child {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 40px;
      }

      :last-child {
        margin-left: initial;
      }
    }
  }
`;

export default NewsLetterSubscriptionForm;
